"use client";
import {
  Image_default
} from "./chunk-KBWHYFNM.mjs";
import {
  Link_default
} from "./chunk-ZRVIWEMV.mjs";
import {
  Icon_default
} from "./chunk-KJNGPZGH.mjs";

// src/components/sections/BannerCardVertical/BannerCardVertical.tsx
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var BannerCardVertical = forwardRef(
  function BannerCardVertical2({
    tag,
    title,
    description,
    link,
    linkLabel,
    image,
    referId
  }) {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: "flex flex-col w-full bg-display-100 rounded-2xl",
        id: referId,
        children: [
          /* @__PURE__ */ jsxs("div", { className: "flex flex-col p-24 lg:p-40", children: [
            tag && /* @__PURE__ */ jsx("p", { className: "font-sans font-bold text-stone-700 uppercase text-sm leading-3", children: tag }),
            title && /* @__PURE__ */ jsx("h2", { className: "max-w-[430px] mt-16 font-display text-3xl lg:text-4xl font-bold leading-7 lg:leading-8", children: title }),
            description && /* @__PURE__ */ jsx("p", { className: "max-w-[430px] mt-8 font-sans md:text-lg md:leading-[26px] text-base leading-4", children: description }),
            link && /* @__PURE__ */ jsx(
              Link_default,
              {
                href: link.href,
                className: "flex items-center mt-16 w-max text-stone-500 hover:text-stone-700",
                onClick: link.onClick,
                children: /* @__PURE__ */ jsxs("div", { className: "flex items-center w-full border border-transparent hover:border-b-stone-700", children: [
                  /* @__PURE__ */ jsx("p", { className: "mr-4 font-medium font-sans text-current md:text-lg md:leading-[26px] text-base leading-4", children: linkLabel }),
                  /* @__PURE__ */ jsx(
                    Icon_default,
                    {
                      name: "chevronRight",
                      className: "mx-auto w-16 md:w-24 h-16 md:h-24 fill-current"
                    }
                  )
                ] })
              }
            )
          ] }),
          image && /* @__PURE__ */ jsx("div", { className: "flex rounded-b-2xl overflow-hidden relative flex-auto w-full min-h-[280px] max-h-[280px]", children: /* @__PURE__ */ jsx(
            Image_default,
            {
              src: image.path,
              alt: image.alternativeText,
              width: 510,
              height: 280,
              layout: "responsive",
              className: "object-cover"
            }
          ) })
        ]
      }
    );
  }
);
var BannerCardVertical_default = BannerCardVertical;

export {
  BannerCardVertical_default
};
